export enum AuthRoutePath {
  LOGIN = 'login',
  SET_PASSWORD = 'set-password',
  FORGOT_PASSWORD = 'forgot-password',
  RESET_PASSWORD = 'reset-password',
}
